import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { TextInput } from "../../../components/textInput/textInput";
import { FindItemIcon } from "../../../assets/icons";
import { useEffect, useState } from "react";
import { CafeItem } from "./cafeItem";
import { PageLoader } from "../../../components/loader/pageLoader";
import SuperAdminAPI from "../../../api/SuperAdminAPI";

import styles from "./cafeList.module.css"
import { Button } from "../../../components/button/button";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { Text } from "../../../components/text/text";

export const CafeListPage = () => {
    const [cafes, setCafes] = useState([]);
    const [search, setSearch] = useState("");

    const [cafesLoading, setCafesLoading] = useState(false);
    useEffect(() => {
        setCafesLoading(true);
        SuperAdminAPI
            .fetchCafes()
            .then(res => setCafes(res))
            .catch(console.error)
            .finally(() => setCafesLoading(false));
    }, []);

    const openPage = useOpenPage();

    const withoutCategory = [];
    const categories = {};
    for (const item of cafes) {
        if (item.group) {
            if (!Object.keys(categories).includes(item.group)) {
                categories[item.group] = [item];
            } else {
                categories[item.group].push(item);
            }
        } else {
            withoutCategory.push(item);
        }
    }


    return (
        <>
            <AdminHeader title="Ваши предприятия" />
            <TextInput value={search} setValue={setSearch} leftContent={<FindItemIcon />} />

            {
                cafesLoading &&
                <PageLoader />
            }

            {
                !cafesLoading &&
                <div className={styles.categories}>
                    {
                        withoutCategory.length > 0 &&
                        <div className={styles.coffee_shops_buttons}>
                            {
                                withoutCategory.filter(item => item.name.toLowerCase().includes(search.trim().toLowerCase())).map(data =>
                                    <CafeItem key={data.id} data={data} />
                                )
                            }
                        </div>
                    }

                    {
                        Object.keys(categories).map(group => (
                            <div className={styles.category} key={group}>
                                <Text as="div" variant="body" className={styles.category_name} >{group}</Text>
                                <div className={styles.coffee_shops_buttons}>
                                    {
                                        categories[group].filter(item => item.name.toLowerCase().includes(search.trim().toLowerCase())).map(data =>
                                            <CafeItem key={data.id} data={data} />
                                        )
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
            }

            <div className={styles.pageSpacer} />

            <div className={styles.bottomActions}>
                <Button
                    text="Получить сравнительный отчёт по выручке"
                    onClick={openPage(`/superadmin/comparative-revenue-report`)}
                />
                <Button
                    text="Добавить предприятие"
                    onClick={openPage(`/superadmin/cafe/create`)}
                />
            </div>
        </>
    )
}
